import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { forgotPassword } from '../../utils/queries';
import AuthCard, { FormError, FormSuccess, TextField } from './AuthCard';

const ForgotSchema = Yup.object().shape({
	email: Yup.string().trim().email('Enter a valid email address.').required('Email is required.'),
});

export default function ForgotPassword() {
	const [sent, setSent] = useState('');

	const handleSubmit = async (values, { setSubmitting, setStatus }) => {
		setStatus(undefined);

		const response = await forgotPassword(values.email.trim());
		setSubmitting(false);

		if (response?.error) {
			setStatus(response.error);
			return;
		}

		setSent(response?.data || 'If an account exists for that email, a password reset link has been sent.');
	};

	return (
		<AuthCard title='Forgot your password?' subtitle="Enter your email and we'll send you a reset link">
			<FormSuccess message={sent} />

			{!sent && (
				<Formik initialValues={{ email: '' }} validationSchema={ForgotSchema} onSubmit={handleSubmit}>
					{({ isSubmitting, status }) => (
						<Form className='space-y-4'>
							<FormError message={status} />
							<TextField
								name='email'
								label='Email address'
								type='email'
								placeholder='Enter your email'
								autoComplete='email'
							/>
							<button
								type='submit'
								disabled={isSubmitting}
								className='btn-primary disabled:opacity-50 disabled:cursor-not-allowed'
							>
								{isSubmitting ? 'Sending...' : 'Send reset link'}
							</button>
						</Form>
					)}
				</Formik>
			)}

			<p className='text-center text-sm text-gray-600'>
				<Link to='/login' className='text-pi-red hover:underline'>
					Back to sign in
				</Link>
			</p>
		</AuthCard>
	);
}
